import { api } from 'API';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/PayslipsAndForms106';

export interface IPaychecks {
  forms106: IForms106[];
  payslips: IPayslips[];
}

export interface IForms106 {
  year: string;
  id: string;
}
export interface IPayslips {
  year: string;
  month: string;
  fileId: string;
  accessibleFileId: string;
  deduction?: number;
  net?: number;
}

export interface IFile {
  id: number;
  file: string;
}

export const getPaychecksAnd106Forms = async () => {
  const res = await api.get<IPaychecks>(addImposterToUrl(baseUrl, true));
  if (res) return res;
};

export const getPaychecks = async (limit: number) => {
  const res = await api.get<IPayslips[]>(
    addImposterToUrl(`${baseUrl}/Payslips?limit=${limit}`, false)
  );
  if (res) return res.data;
};

export const getPaycheck = async () => {
  const res = await api.get<IPayslips[]>(
    addImposterToUrl(`${baseUrl}/Payslips?limit=1`, false)
  );
  if (res) return res.data[0];
};

export const getForm106 = async () => {
  const res = await api.get<IForms106[]>(
    addImposterToUrl(`${baseUrl}/Forms106?limit=1`, false)
  );
  if (res) return res.data[0];
};

export const getPayslipFile = async (fileId: string) => {
  const res = await api.get<IFile>(
    addImposterToUrl(`${baseUrl}/payslip/${fileId}`, true)
  );
  if (res.data) return res.data;
};

export const getAccessiblePayslipFile = async (fileId: string) => {
  const res = await api.get<IFile>(
    addImposterToUrl(`${baseUrl}/AccessiblePayslip/${fileId}`, true)
  );
  if (res.data) return res.data;
};

export const getForm106File = async (fileId: string) => {
  const res = await api.get<IFile>(
    addImposterToUrl(`${baseUrl}/form106/${fileId}`, true)
  );
  if (res.data) return res.data;
};

export const getSummarizedPaychecks = async (limit: number = 0) => {
  const res = await api.get<IPayslips[]>(
    addImposterToUrl(`${baseUrl}/SummarizedPayslips?limit=${limit}`, false)
  );
  if (res) return res;
};
